import React, { useState } from 'react';
import './App.css';

function App() {
  const skills = [
    'Java', 'Python', 'C', 'JavaScript', 'SQL', 'Spring Boot',
    'OpenCV', 'React', 'AI detection', 'Linux', 'Git', 'MySQL'
  ];

  const projects = [
    {
      title: 'AI-Powered Computer Vision Aimbot',
      description: 'Advanced AI aimbot for FPS games using YOLOv5-s object detection and OpenCV with PID controller for natural mouse movements',
      technologies: 'Python, YOLOv5, OpenCV, AI/ML',
      url1: null,
      liveUrl: null,
      demoVideo: '/videos/aimbot-demo.mp4',
      demoPoster: '/videos/aimbot-demo-poster.jpg'
    },
    {
      title: 'Bookstore SaaS Platform',
      description: 'Full-stack web application with inventory management, search functionality, and recommendation system using Jaccard distance',
      technologies: 'Spring Boot, Java, MySQL, GitHub Actions',
      url1: 'https://github.com/tunauygun/AmazinBookstore',
      liveUrl: 'https://amazinbookstoreapp-e6arfpg3ezc9ezep.canadacentral-01.azurewebsites.net/amazinBookstore'
    },
    {
      title: 'UNO Flip Card Game',
      description: 'Java implementation of UNO Flip card game featuring MVC architecture, Observer design pattern, and GUI with game state management',
      technologies: 'Java, MVC Pattern, Observer Pattern, Swing GUI',
      url1: 'https://github.com/UselessBen1/uno-flip-game',
      liveUrl: null,
      demoVideo: '/videos/unoflip.mp4'
    },
    {
      title: 'Real-Time Elevator Control System',
      description: 'Distributed, multithreaded elevator simulation with UDP socket communication and real-time synchronization',
      technologies: 'Java, UDP Sockets, Multithreading',
      url1: 'https://github.com/UselessBen1/SYSC3303-elevator/tree/chainging-scheduler-to-work-seamlessly',
      url2: null,
      liveUrl: null,
      demoVideo: '/videos/elevator-demo.mp4',
      demoPoster: '/videos/elevator-demo-poster.jpg'
    },
    {
      title: 'MSP432 LaunchPad Real-Time Simulation',
      description: 'Embedded system programming with real-time task scheduling and hardware I/O interactions',
      technologies: 'C, MSP432, Embedded Systems',
      url1: 'https://github.com/UselessBen1/msp432-simulation',
      liveUrl: null
    }
  ];

  const defaultContactEndpoint = 'https://formsubmit.co/ajax/benbenchen@outlook.com';
  const contactEndpoint = process.env.REACT_APP_CONTACT_FORM_ENDPOINT || defaultContactEndpoint;
  const [contactForm, setContactForm] = useState({
    sender: '',
    topic: '',
    content: ''
  });
  const [honeypot, setHoneypot] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [formStatus, setFormStatus] = useState({
    type: '',
    message: ''
  });

  const handleContactChange = (event) => {
    const { name, value } = event.target;
    setContactForm((previous) => ({
      ...previous,
      [name]: value
    }));
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();

    if (!contactEndpoint) {
      setFormStatus({
        type: 'error',
        message: 'Contact form is not configured yet.'
      });
      return;
    }

    const sender = contactForm.sender.trim();
    const topic = contactForm.topic.trim();
    const content = contactForm.content.trim();

    if (!sender) {
      setFormStatus({
        type: 'error',
        message: 'Email is required.'
      });
      return;
    }

    setIsSending(true);
    setFormStatus({
      type: '',
      message: ''
    });

    const payload = new FormData();
    payload.append('_subject', `Portfolio Contact: ${topic}`);
    payload.append('topic', topic);
    payload.append('message', content);
    payload.append('email', sender);
    payload.append('sender', sender);
    payload.append('_replyto', sender);
    payload.append('_honey', honeypot);
    payload.append('_captcha', 'true');

    try {
      const response = await fetch(contactEndpoint, {
        method: 'POST',
        referrerPolicy: 'strict-origin-when-cross-origin',
        headers: {
          Accept: 'application/json'
        },
        body: payload
      });

      let result = null;
      try {
        result = await response.json();
      } catch (parseError) {
        result = null;
      }

      const formSubmitSucceeded =
        result && (result.success === true || result.success === 'true');

      if (!response.ok || !formSubmitSucceeded) {
        const providerMessage = result && result.message ? result.message : null;
        throw new Error(providerMessage || 'Failed to submit contact form');
      }

      setContactForm({
        sender: '',
        topic: '',
        content: ''
      });
      setHoneypot('');
      setFormStatus({
        type: 'success',
        message: 'Message sent successfully.'
      });
    } catch (error) {
      setFormStatus({
        type: 'error',
        message: error.message || 'Unable to send message right now. Please try again later.'
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
      <div className="App">
        {/* Header Section */}
        <header className="header">
          <div className="container">
            <nav className="nav">
              <h1 className="logo">Bochen Li</h1>
              <ul className="nav-links">
                <li><a href="#about">About</a></li>
                <li><a href="#skills">Skills</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </nav>
          </div>
        </header>

        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <h2>Hello, I'm a Software Engineer</h2>
              <p>Software engineering graduate with SaaS and full-stack development experience, passionate about solving technical challenges across the full system stack</p>

            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="about">
          <div className="container">
            <h2>About Me</h2>
            <div className="about-content">
              <div className="about-text">
                <p>
                  I'm a Software Engineering graduate with extensive experience
                  in SaaS and full-stack development. My expertise spans across all layers of IT: From
                  hardware and computer architecture to software deployment in modern cloud systems.
                </p>
                <p>
                  I have hands-on experience with AI/ML projects, real-time systems, embedded programming,
                  and web development. I'm passionate about creating efficient, scalable solutions and
                  enjoy tackling complex technical challenges across the full system stack.
                </p>
                
              </div>
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section id="skills" className="skills">
          <div className="container">
            <h2>Skills</h2>
            <div className="skills-grid">
              {skills.map((skill, index) => (
                  <div key={index} className="skill-item">
                    {skill}
                  </div>
              ))}
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="projects" className="projects">
          <div className="container">
            <h2>Projects</h2>
            <div className="projects-grid">
              {projects.map((project, index) => (
                  <div key={index} className="project-card">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <div className="project-tech">{project.technologies}</div>
                    <div className="project-links">
                      {project.url1 && (
                          <a href={project.url1} target="_blank" rel="noopener noreferrer" className="project-link github-link">
                            {project.url1.includes('github.com') ? 'GitHub' : 'View Project'}
                          </a>
                      )}
                      {project.url2 && (
                          <a href={project.url2} target="_blank" rel="noopener noreferrer" className="project-link github-link">
                            {project.url2.includes('github.com') ? 'GitHub' : 'View Project'}
                          </a>
                      )}
                      {project.liveUrl && (
                          <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="project-link live-link">
                            Live Demo
                          </a>
                      )}
                    </div>
                    {project.demoVideo && (
                        <div className="project-demo">
                          <video
                            className="project-demo-video"
                            controls
                            preload="metadata"
                            playsInline
                            poster={project.demoPoster}
                          >
                            <source src={project.demoVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                    )}
                  </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="contact">
          <div className="container contact-container">
            <h2>Contact</h2>
            
            <form className="contact-form" onSubmit={handleContactSubmit}>
              <div className="contact-honeypot" aria-hidden="true">
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  type="text"
                  name="website"
                  value={honeypot}
                  onChange={(event) => setHoneypot(event.target.value)}
                  autoComplete="off"
                  tabIndex={-1}
                />
              </div>

              <label className="form-label" htmlFor="sender">
                Your Email
              </label>
              <input
                id="sender"
                className="contact-input"
                type="email"
                name="sender"
                value={contactForm.sender}
                onChange={handleContactChange}
                required
                maxLength={120}
                placeholder="name@example.com"
              />

              <label className="form-label" htmlFor="topic">
                Topic
              </label>
              <input
                id="topic"
                className="contact-input"
                type="text"
                name="topic"
                value={contactForm.topic}
                onChange={handleContactChange}
                required
                maxLength={120}
                placeholder="What is this about?"
              />

              <label className="form-label" htmlFor="content">
                Content
              </label>
              <textarea
                id="content"
                className="contact-textarea"
                name="content"
                value={contactForm.content}
                onChange={handleContactChange}
                required
                rows="6"
                maxLength={3000}
                placeholder="Write your message..."
              />

              <button className="contact-submit" type="submit" disabled={isSending}>
                {isSending ? 'Sending...' : 'Send Message'}
              </button>

              {formStatus.message && (
                  <p
                    className={`contact-status ${
                      formStatus.type === 'success' ? 'contact-status-success' : 'contact-status-error'
                    }`}
                  >
                    {formStatus.message}
                  </p>
              )}
            </form>
          </div>
        </section>

      </div>
  );
}

export default App;
